import { useRef, useMemo, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { createSearchParams, getSearchParamsForLocation } from './helpers';

export const useSearchParams = (defaultInit) => {
  const defaultSearchParamsRef = useRef(createSearchParams(defaultInit));
  const hasSetSearchParamsRef = useRef(false);

  const location = useLocation();
  const searchParams = useMemo(
    () =>
      getSearchParamsForLocation(
        location.search,
        hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current
      ),
    [location.search]
  );

  const history = useHistory();
  const setSearchParams = useCallback(
    (nextInit) => {
      const newSearchParams = createSearchParams(
        typeof nextInit === 'function' ? nextInit(searchParams) : nextInit
      );
      hasSetSearchParamsRef.current = true;
      history.replace({
        search: newSearchParams.toString(),
      });
    },
    [history.replace, searchParams.toString()]
  );

  return [searchParams, setSearchParams];
};
